import { get, post, put, remove } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";

export interface FeatureToggle {
  id: string;
  key: string;
  name: string;
  description: string;
  isEnabled: boolean;
  isEnabledForQueri: boolean;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
}

export interface CreateFeatureToggleDto {
  key: string;
  name: string;
  description?: string;
  isEnabled?: boolean;
  isEnabledForQueri?: boolean;
}

export interface UpdateFeatureToggleDto {
  isEnabled?: boolean;
  isEnabledForQueri?: boolean;
  name?: string;
  description?: string;
}

export const getAllFeatureToggles = (): Promise<ApiResponse<FeatureToggle[]>> => {
  return get(`/feature-toggles`, null);
};

export const getFeatureToggle = (key: string): Promise<ApiResponse<FeatureToggle>> => {
  return get(`/feature-toggles/${key}`, null);
};

export const createFeatureToggle = (dto: CreateFeatureToggleDto): Promise<ApiResponse<FeatureToggle>> => {
  return post(`/feature-toggles`, dto);
};

export const updateFeatureToggle = (key: string, dto: UpdateFeatureToggleDto): Promise<ApiResponse<FeatureToggle>> => {
  return put(`/feature-toggles/${key}`, dto);
};

export const deleteFeatureToggle = (key: string): Promise<ApiResponse<void>> => {
  return remove(`/feature-toggles/${key}`, null);
};

export const checkFeatureToggle = (key: string): Promise<ApiResponse<{ isEnabled: boolean }>> => {
  return get(`/feature-toggles/check/${key}`, null);
};
